import {
  Grid,
  Box,
  Select,
  MenuItem,
  Card,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Divider,
  LinearProgress,
  Autocomplete,
  TextField,
} from "@mui/material";
import ReactApexChart from "react-apexcharts";
import DateRangeWithTime from "../summary/dateRange";
import CardComponent from "../overview/cardComponent";
import { Fragment, useEffect, useState } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import { useAppDispatch, useAppSelector } from "../../store/store";
import moment from "moment";
import { LabelIcons } from "../newDashboard/Svg/labelIcons";
import CircularProgress from "@mui/material/CircularProgress";
import { checkWithSubstanceOneDecimal } from "../../constants";
import { exportSubstanceReport } from "../../store/thunk/dashboardThunk";
import { setLoader } from "../../store/slices/authSlice";
import { notificationSuccess } from "../../store/slices/notificationSlice";
import DetailSkeleton from "../../skeleton/mainView/DetailSkeleton";
import { DateFormat, DateTimeFormat, TimeFormat } from "../common/DateFormat";
import { getNumberUnits } from "../../helper/service";
import { GetSubstanceDetail } from "../../store/thunk/substanceThunk";
import { getSubstanceDetailList } from "../../store/slices/substanceSlice";

var chartLabels: any = [];
var xcount = 0;
export function DetailSummary(props: any) {
  const {
    maxWrostData,
    substance,
    handleChangeLocation,
    substanceLoc,
    roomLocationName = [],
    handleChangeSubstance,
    substanceDetailLocation = {},
    setDateRangeChange,
    setSubstanceChange,
    dateRange,
    customLoader,
    loading,
    relatedSubstanceData = [],
    getSummaryData,
    variant,
    handleExportedReportClick,
    facilityKey,
    summaryLoader,
    substanceChange,
    setCustomLoader,
    relatedSubstancesLoader,
    thirdPartySummary = false,
    deviceReading,
    metricsKey
  } = props;

  const [interval, setIntervalState] = useState("1m");
  const [options, setOptions] = useState<any>([]);
  const [onlyAtFirstDetailLoading, setOnlyAtFirstDetailLoading] =
    useState<boolean>(true);
  const [onlyAtSecondDetailLoading, setOnlyAtSecondDetailLoading] =
    useState<boolean>(true);
  const [graphDataSeries, setGraphDataSeries] = useState<any>([]);
  const [thirdPartygraphDataSeries, setThirdPartygraphDataSeries] = useState<any>([]);
  const [substanceKey, setSubstanceKey] = useState<any>("");
  const [substanceName, setSubstanceName] = useState<any>("");
  const [substanceData, setSubstanceData] = useState<any>([]);
  const [substanceExportData, setExportSubstanceData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isDataSet, setIsDataSet] = useState<any>();
  const [intervalDisabled, setIntervalDisabled] = useState<any>({
    "1m": false,
    "5m": false,
    "1h": false,
    "1d": false,
    "7d": false,
    "30d": false,
  });
  const { themeMode } = useAppSelector((state: any) => state.themeSlice);
  const initialGraphOptions = {
    options: {
      chart: {
        animations: {
          enabled: false,
        },
        height: 350,
        type: "bar",
        events: {
          click: function (chart: any, w: any, e: any) { },
        },
      },
      tooltip: {
        theme: themeMode,
        x: {
          show: true,
          formatter: function (val: any) {
            return moment(val)
              .tz(userData?.timezone || moment.tz.guess())
              .format(DateTimeFormat());
          },
        },
        y: {
          title: {
            formatter: function (val: any, opt: any) {
              return;
            },
          },
        },
      },
      plotOptions: {
        bar: {
          columnWidth: "45%",
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      xaxis: {
        rotateAlways: false,
        categories: [],
        labels: {
          rotate: 0,
          datetimeUTC: false,
          formatter: function (value: any) {
            let modulo: any = Math.round(chartLabels.length / 10);
            xcount = xcount + 1;
            if (xcount % (modulo || 1) === 0) {
              return [
                moment(value)
                  .tz(userData?.timezone || moment.tz.guess())
                  .format(TimeFormat()),
                moment(value)
                  .tz(userData?.timezone || moment.tz.guess())
                  .format(DateFormat()),
              ];
            }
            return "";
          },
          style: {
            fontSize: "10px",
            colors: themeMode === "dark" ? "#fff" : "#000",
          },
        },
      },
      yaxis: {
        forceNiceScale: true,
        labels: {
          style: {
            colors: themeMode === "dark" ? "#fff" : "#000",
          },
          formatter: (value: any) => {
            return value === Infinity
              ? 0
              : value > 0 && value < 0.1
                ? Number(value).toFixed(4)
                : getNumberUnits(value);
          },
        },
      },
    },
  };
  const initialGraphOptions2 = {
    options: {
      chart: {
        animations: {
          enabled: false,
        },
        height: 350,
        type: "bar",
        zoom: {
          enabled: false, // Disable zoom/selection
        },
        events: {
          click: function (chart: any, w: any, e: any) { },
        },
      },
      tooltip: {
        theme: themeMode,
        x: {
          show: true,
          formatter: function (val: any) {
            return moment(val)
              .tz(userData?.timezone || moment.tz.guess())
              .format(DateTimeFormat());
          },
        },
        y: {
          title: {
            formatter: function (val: any, opt: any) {
              return;
            },
          },
        },
      },
      plotOptions: {
        bar: {
          columnWidth: "45%",
          distributed: true,
        },
      },
      dataLabels: {
        enabled: false,
      },
      legend: {
        show: false,
      },
      xaxis: {
        rotateAlways: false,
        categories: [],
        // Note: type is added later when updating the state
      },
      yaxis: {
        forceNiceScale: true,
        labels: {
          style: {
            colors: themeMode === "dark" ? "#fff" : "#000",
          },
          formatter: (value: any) => {
            return value === Infinity
              ? 0
              : value > 0 && value < 0.1
                ? Number(value).toFixed(4)
                : getNumberUnits(value);
          },
        },
      },
    },
  };

  const [graphDataOptions, setGraphOptions] = useState<any>(initialGraphOptions);
  const [thirdPartygraphDataOptions, setThirdPartygraphDataOptions] = useState<any>(initialGraphOptions2);

  const { substancedetails, substanceThresholdsList, substanceConfigurationList } = useAppSelector(
    (state: any) => state.substanceSlice
  );
  const { userData }: any = useAppSelector((state) => state.authReducer);
  const dispatch: any = useAppDispatch();

  const handleChangeInterval = (event: any) => {
    setSubstanceChange(true);
    setIsLoading(true);
    setIntervalState(event.target.value);
  };

  const handleChangeDate = (value: any) => {
    setSubstanceChange(true);
    setIsLoading(true);
    setDateRangeChange(value);
  };

  const HandleRealatedSub = (item: any, location: any, isRelatedData: any) => {
    const items = JSON.parse(localStorage.getItem("tenantId") || "{}");
    const tenantCode = items && items?.tenantId ? items?.tenantCode : userData?.tenantCode;
    if(tenantCode !== process.env.REACT_APP_TENANT_CODE){
      setGraphOptions((prev: any) => ({ ...initialGraphOptions })); // Ensure a new object reference
      setGraphDataSeries([]);
      getSummaryData(item, location, isRelatedData);
    }else{
      // setGraphOptions((prev: any) => ({ ...initialGraphOptions })); // Ensure a new object reference
      // setGraphDataSeries([]);
      console.log('fetchSubstanceDetails');      
      fetchSubstanceDetails()
    }    
  };

  const fetchSubstanceDetails = async () => {
    //set the  interval manually
    let graphInterval = interval;
    if (typeof dateRange?.startDate === "string") {
      const start = moment(dateRange?.startDate);
      const end = moment(dateRange?.endDate);
      const hoursDiff = end.diff(start, "hours");

      if (
        hoursDiff <= 3 &&
        interval != "1m" &&
        interval != "5m" &&
        interval != "1h"
      ) {
        graphInterval = "1m";
      } else if (
        hoursDiff > 3 &&
        hoursDiff <= 12 &&
        interval != "5m" &&
        interval != "1h"
      ) {
        graphInterval = "5m";
      } else if (hoursDiff > 12 && (interval === "1m" || interval === "5m")) {
        graphInterval = "1h";
      }
    }

    if (typeof dateRange?.startDate === "object") {
      const start = dateRange?.startDate;
      const end = dateRange?.endDate;
      const hoursDiff = end.diff(start, "hours");

      if (
        hoursDiff <= 3 &&
        interval != "1m" &&
        interval != "5m" &&
        interval != "1h"
      ) {
        graphInterval = "1m";
      } else if (
        hoursDiff > 3 &&
        hoursDiff <= 12 &&
        interval != "5m" &&
        interval != "1h"
      ) {
        graphInterval = "5m";
      } else if (hoursDiff > 12 && (interval === "1m" || interval === "5m")) {
        graphInterval = "1h";
      }
    }

    if (substance && Object.keys(substance).length && dateRange !== null) {
      const params = {
        interval: graphInterval,
        location: substanceLoc,
        substanceKey: substance?.substanceKey,
        fromDate: moment(dateRange.startDate).format("Y-MM-DD HH:mm:ssZ"),
        toDate: moment(dateRange.endDate).format("Y-MM-DD HH:mm:ssZ"),
      };

      if (graphInterval != interval) {
        //when we set the interval manually so it set here and in above useEffect when interval change then it run the same function and execute below dispatch query.
        setIntervalState(graphInterval);
        setIsLoading(false);
      } else {
        //Call the API when interval and graphInterval is same
        dispatch(GetSubstanceDetail(params))
          .then((response: any) => {
            console.log("Success:", response);
            if (response?.payload?.data?.getSubstanceDetails?.measures === null) {
              setCustomLoader(false);
            }
            setIsLoading(false);
          })
          .catch((error: any) => {
            console.error("Error:", error);
            setCustomLoader(false);
          })
      }
    }
  };

  useEffect(() => {
    if (substance?.substanceKey) {
      const substanceData = substanceConfigurationList?.find((item: any) => item.substanceKey === substance?.substanceKey)
      console.log("setSubstanceKey ::", substance, substanceData);
      setSubstanceKey(substance?.substanceKey)
      setSubstanceName(substanceData?.displayName)
    }
  }, [
    substance?.substanceKey, substanceConfigurationList
  ]);

  useEffect(() => {
    // dispatch(getSubstanceDetailList({}));
    if (!thirdPartySummary) {
      fetchSubstanceDetails();
    }
  }, [
    substance?.substanceKey,
    interval,
    dateRange,
    maxWrostData,
    substanceLoc,
  ]);

  //For generating graph options and graph data series

  useEffect(() => {
    const { xaxis } = graphDataOptions.options;
    const { yaxis } = graphDataOptions.options;
    const { plotOptions } = graphDataOptions.options;
    const { options } = graphDataOptions;
    let colors: any = [];
    let valuesData: any = [];
    let categories: any = [];
    setIsDataSet(true)
    console.log("substancedetails",substancedetails);    
    if (substancedetails?.measures && substancedetails.measures.length > 0) {
      const sortedArray = [...substancedetails.measures].sort(
        (c1: any, c2: any) => c1.time - c2.time
      );
      sortedArray.map((val: any) => {
        let num = typeof val.value;
        let value =
          num === "number" ? parseFloat(val.value).toFixed(4) : val.value;
        colors.push(val.color);
        valuesData.push(value < 0 ? 0 : value);
        const date = moment?.unix(val.time)?.utc(false).format("DD-MM LT");
        categories.push(val.time * 1000);
      });
    } else {
      //If last 3 days substance graph details not found then i fetch last 30 days grpah substance detail for generating graph
      //It work only one time when we come to details page form summary page
      if (substanceLoc && substance?.substanceKey && onlyAtFirstDetailLoading) {
        setDateRangeChange({
          ...dateRange,
          startDate: moment()
            .startOf("minute")
            .subtract(1, "hour")
            .subtract(2, "days"),
          endDate: moment().startOf("minute"),
        });
        setIntervalState("1h");
        setOnlyAtFirstDetailLoading(false);
      } else if (
        substanceLoc &&
        substance?.substanceKey &&
        onlyAtSecondDetailLoading
      ) {
        setDateRangeChange({
          ...dateRange,
          startDate: moment(dateRange.endDate)
            .subtract(30, "days"),
          endDate: moment(dateRange.endDate),
        });
        setIntervalState("1d");
        setOnlyAtSecondDetailLoading(false);
      }
    }
    chartLabels = categories;
    xcount = 0;
    setGraphDataSeries(valuesData);
    setGraphOptions({
      ...graphDataOptions,
      options: {
        ...options,
        plotOptions: {
          ...plotOptions,
          bar: {
            ...plotOptions.bar,
            columnWidth: valuesData.length <= "4" ? "5%" : "45%", //for substance threshold full width adjustment
          },
        },
        xaxis: {
          ...xaxis,
          labels: {
            ...xaxis.labels,
            style: {
              ...xaxis.labels.style,
              colors: themeMode === "dark" ? "#fff" : "#000",
            },
          },
          categories: categories,
        },
        yaxis: {
          ...yaxis,
          labels: {
            ...yaxis.labels,
            style: {
              ...yaxis.labels.style,
              colors: themeMode === "dark" ? "#fff" : "#000",
            },
          },
        },
        fill: {
          colors: colors,
        },
      },
    });
    setIsDataSet(false)

  }, [substancedetails?.measures]);


  useEffect(() => {
    const { categories, seriesData } = processData(deviceReading, metricsKey);
    console.log("processData ::", deviceReading, categories, seriesData);
    setIsDataSet(true);
    setThirdPartygraphDataSeries(seriesData);
    chartLabels = categories;
    xcount = 0;

    setThirdPartygraphDataOptions((prevState: any) => ({
      ...prevState,
      options: {
        ...prevState.options,
        colors: ["#808080"],
        plotOptions: {
          ...prevState.options.plotOptions,
          bar: {
            ...prevState.options.plotOptions.bar,
            columnWidth: seriesData.length <= 4 ? "5%" : "45%", // Use seriesData length
          },
        },
        xaxis: {
          ...prevState.options.xaxis,
          type: "datetime", // Ensure x-axis is treated as datetime
          rotateAlways: false,
          categories: categories, // Array of timestamp values
          rotate: 0,
          labels: {
            formatter: function (value: any) {
              // If you want to use moment.js for formatting:
              return [
                moment(value)
                  .tz(userData?.timezone || moment.tz.guess())
                  .format("hh:mm A"), // Example: 10:59 AM
                moment(value)
                  .tz(userData?.timezone || moment.tz.guess())
                  .format("DD MMM YYYY") // Example: 02 Apr 2025
              ];
            },
            style: {
              fontSize: "10px",
              colors: themeMode === "dark" ? "#fff" : "#000",
            },
          },
        },
        yaxis: {
          ...prevState.options.yaxis,
          labels: {
            ...prevState.options.yaxis.labels,
            style: {
              ...prevState.options.yaxis.labels.style,
              colors: themeMode === "dark" ? "#fff" : "#000",
            },
          },
        },
      },
    }));
    setIsDataSet(false);
  }, [deviceReading, themeMode]);


  const processData = (data: { [key: string]: string; time: string }[], metricsKey: string) => {
    if (!Array.isArray(data)) {
      return { categories: [], seriesData: [] };  // Return empty arrays if data is not an array
    }

    const sortedArray = [...data].sort((a: any, b: any) => a.time - b.time);

    const categories: any[] = [];
    const seriesData: number[] = [];
    const colors: string[] = [];

    sortedArray.forEach((val: any) => {
      const numType = typeof val[metricsKey];

      // Convert only if it's a number, and then back to a number after toFixed()
      let value: number =
        numType === "string"
          ? parseFloat(parseFloat(val[metricsKey]).toFixed(4))  // Round to 4 decimal places
          : numType === "number"
            ? parseFloat(val[metricsKey].toFixed(4))  // Round to 4 decimal places
            : NaN;  // Default to NaN if neither string nor number

      value = value < 0 ? 0 : value; // Ensure no negative values

      colors.push(val.color);
      seriesData.push(value);
      categories.push(val.time * 1000); // Convert to milliseconds
    });


    return { categories, seriesData };
  };

  useEffect(() => {
    if (isDataSet) {
      setCustomLoader(false);
    }
  }, [isDataSet]);

  // Set export data based on thresholds available
  useEffect(() => {
    if (substanceThresholdsList) {
      const filtered = substanceThresholdsList.find(
        (x: any) => x?.substanceKey === substance?.substanceKey
      );
      setExportSubstanceData(filtered);
    }
  }, [substanceThresholdsList, substance?.substanceKey]);

  // Set substance measures if available
  useEffect(() => {
    if (substancedetails?.measures) {
      setSubstanceData(substancedetails.measures);
    }
  }, [substancedetails]);

  // Update disabled intervals based on dateRange
  useEffect(() => {
    let start: any = "";
    let end: any = "";
    let hoursDiff: any = 0;
    let daysDiff: any = 0;

    if (typeof dateRange?.startDate === "string") {
      start = moment(dateRange?.startDate);
      end = moment(dateRange?.endDate);
      hoursDiff = end.diff(start, "hours");
      daysDiff = end.diff(start, "days");
    } else {
      start = dateRange?.startDate;
      end = dateRange?.endDate;
      hoursDiff = end.diff(start, "hours");
      daysDiff = end.diff(start, "days");
    }

    if (hoursDiff > 12) {
      setIntervalDisabled({
        ...intervalDisabled,
        "1m": true,
        "5m": true,
        "1h": false,
        "1d": false,
        "7d": daysDiff >= 7 ? false : true,
        "30d": daysDiff >= 28 ? false : true,
      });
    } else if (hoursDiff > 3) {
      setIntervalDisabled({
        ...intervalDisabled,
        "1m": true,
        "5m": false,
        "1h": false,
        "1d": true,
        "7d": daysDiff >= 7 ? false : true,
        "30d": daysDiff >= 28 ? false : true,
      });
    } else if (hoursDiff <= 3) {
      setIntervalDisabled({
        ...intervalDisabled,
        "1m": false,
        "5m": false,
        "1h": false,
        "1d": true,
        "7d": daysDiff >= 7 ? false : true,
        "30d": daysDiff >= 28 ? false : true,
      });
    } else {
      setIntervalDisabled({
        "1m": false,
        "5m": false,
        "1h": false,
        "1d": false,
        "7d": daysDiff >= 7 ? false : true,
        "30d": daysDiff >= 28 ? false : true,
      });
    }
  }, [dateRange]);

  const getThresholdValue = (value: any, flag: string) => {
    if (value === "0") return value;
    if (typeof value === "undefined") return `(${flag} data not available)`;
    return value;
  };

  // Handle export functionality (CSV export)
  const handleExport = () => {
    const sortedData = [...substanceData].sort((a: any, b: any) => a.time - b.time);
    const startDate = moment(dateRange.startDate).format("Y-MM-DD HH:mm:ssZ");
    const toDate = moment(dateRange.endDate).format("Y-MM-DD HH:mm:ssZ");
    const diffMinutes = moment(toDate).diff(startDate, "minutes");

    if (diffMinutes > 10080) {
      dispatch(setLoader(true));
      const request = {
        params: {
          facilityKey,
          interval,
          location: substanceLoc,
          substanceKey: substance?.substanceKey,
          fromDate: startDate,
          toDate,
        },
      };
      dispatch(exportSubstanceReport(request))
        .then((res: any) => {
          dispatch(notificationSuccess(res?.payload?.result));
          handleExportedReportClick();
          dispatch(setLoader(false));
        })
        .catch(() => {
          dispatch(setLoader(false));
        });
    } else {
      const merged = sortedData.map((val: any) => {
        const formattedTime = moment.unix(val.time).utc(true).format("DD-MM LT");
        const record: any = {
          time: String(formattedTime),
          color: val.color,
          color_name:
            val.color === "#000000"
              ? "black"
              : val.color === "#871014"
                ? "red"
                : val.color === "#FFEF5C"
                  ? "yellow"
                  : val.color === "#98E565"
                    ? "green"
                    : "white",
          value:
            typeof val.value === "number" ? parseFloat(val.value).toFixed(4) : val.value,
        };

        substanceExportData?.ranges?.forEach((item: any) => {
          if (item?.index === 1) {
            record["Green"] = `[${getThresholdValue(item?.lower, "Lower")}-${getThresholdValue(
              item?.upper,
              "Upper"
            )}]`;
          }
          if (item?.index === 2) {
            record["Yellow"] = `[${getThresholdValue(item?.lower, "Lower")}-${getThresholdValue(
              item?.upper,
              "Upper"
            )}]`;
          }
          if (item?.index === 4) {
            record["Red"] = `[${getThresholdValue(item?.lower, "Lower")}-${getThresholdValue(
              item?.upper,
              "Upper"
            )}]`;
          }
          if (item?.index === 5) {
            record["Black"] = `[${getThresholdValue(item?.lower, "Lower")}-${getThresholdValue(
              item?.upper,
              "Upper"
            )}]`;
          }
        });
        return record;
      });

      if (merged.length > 0) {
        const header = Object.keys(merged[0]).join(",");
        const csvContent = [header, ...merged.map((r) => Object.values(r).join(","))].join("\n");
        const csvFile = new Blob([csvContent], { type: "text/csv" });
        const downloadLink = document.createElement("a");
        downloadLink.download = `substance-report-${substance?.substance === "alcohol" ? "4ch3oh" : substance?.substance || "data"
          }-${moment().unix()}.csv`;
        downloadLink.href = window.URL.createObjectURL(csvFile);
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        handleExportedReportClick();
      }
    }
  };

  const getSubstanceUnit = () => {
    if (substance?.substanceKey === "temperature") return ` ${userData?.temperature_unit || "f"}`;
    if (["pm_biop", "pc_biop"].includes(substance?.substanceKey)) return " %";
    if (["ug/m3", "#M/m3"].includes(substance?.unit)) return "";
    return ` ${substance?.unit || ""}`;
  };

  useEffect(() => {
    let readings =
      substanceDetailLocation?.data?.[0]?.readings?.sort((a: any, b: any) =>
        a.displayName.toLowerCase() < b.displayName.toLowerCase() ? -1 : 1
      ) || [];

    console.log("setSubstanceKey ::", readings, "selected key:", substanceKey);
    setOptions(readings);
  }, [substanceDetailLocation, substanceKey, substanceName]);

  console.log("substanceDetailLocation :", substanceDetailLocation);

  // If summaryLoader is true and substanceChange is false, show skeleton
  if (summaryLoader && !substanceChange) {
    return (
      <>
        <LinearProgress color="secondary" />
        <DetailSkeleton />
      </>
    );
  }


  return (
    <>
      {(maxWrostData && Object.keys(maxWrostData).length > 0) || (thirdPartySummary && thirdPartygraphDataSeries.length > 0) ? (
        <>
          {/* Top Controls */}
          {!thirdPartySummary && <Grid container sx={{ px: 3, alignItems: "center" }}>
            <Grid item md={12} xs={12} sx={{ my: 1 }} className="summary-left-block">
              <Box sx={{ display: "flex", flexWrap: "wrap" }} className="summary-left-widget">
                {/* Location Select */}
                <Box
                  sx={{
                    mr: 2,
                    mt: { xs: 3 },
                    width: { xs: "100%", sm: "10em" },
                  }}
                >
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel>Location</InputLabel>
                    <Select
                      variant="outlined"
                      name="location"
                      label="Location"
                      sx={{
                        height: 38,
                        background: "#FFFFFF",
                        padding: "7px",
                        "& .MuiSelect-select": {
                          opacity: substance?.substance === "" ? "0.5" : "1",
                        },
                      }}
                      onChange={handleChangeLocation}
                      value={substanceLoc}
                      renderValue={interval !== null ? undefined : () => "Select Location"}
                    >
                      {roomLocationName.map((item: any, index: number) => (
                        <MenuItem key={index} value={item?.roomLocationId}>
                          <LabelIcons type={"R"} size={16} />
                          {` ${item?.roomLocationName}`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                {/* Substance Select */}
                <Box
                  sx={{
                    mr: 2,
                    mt: { xs: 3 },
                    width: { xs: "100%", sm: "10em" },
                  }}
                >
                  {/* <FormControl variant="outlined" fullWidth>
                    <InputLabel>Characteristics</InputLabel>
                    <Select
                      variant="outlined"
                      name="substance"
                      label="Characteristics"
                      sx={{
                        height: 38,
                        background: "#FFFFFF",
                        padding: "7px",
                        "& .MuiSelect-select": {
                          opacity: substance?.substance === "" ? "0.5" : "1",
                        },
                      }}
                      onChange={handleChangeSubstance}
                      value={substanceKey}
                      renderValue={interval !== null ? undefined : () => "Select Characteristics"}
                    >
                      {substanceDetailLocation?.data?.[0]?.readings
                        ?.sort((a: any, b: any) =>
                          a.displayName.toLowerCase() < b.displayName.toLowerCase() ? -1 : 1
                        )
                        .map((item: any, index: number) => (
                          <MenuItem key={index} value={item?.substanceKey}>
                            {item.displayName}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl> */}
                  <Autocomplete
                    fullWidth
                    disableClearable
                    options={options}
                    getOptionLabel={(option) => option.displayName || ""}
                    value={options.find((item: any) => item.substanceKey === substanceKey) || { displayName: substanceName, substanceKey: substanceKey }}
                    onChange={(event, newValue) => handleChangeSubstance({ target: { value: newValue?.substanceKey } })}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Characteristics"
                        variant="outlined"
                        sx={{
                          background: "#FFFFFF",
                          "& .MuiInputBase-root": {
                            height: 38,
                            padding: "0 7px",
                          },
                          "& input": {
                            opacity: !substance?.substance ? "0.5" : "1",
                          },
                        }}
                      />
                    )}
                  />
                </Box>
                {/* Interval Select */}
                <Box
                  sx={{
                    mr: 2,
                    mt: { xs: 3 },
                    width: { xs: "100%", sm: "10em" },
                  }}
                >
                  <FormControl variant="outlined" fullWidth>
                    <InputLabel>Interval</InputLabel>
                    <Select
                      variant="outlined"
                      name="interval"
                      label="Interval"
                      sx={{
                        height: 38,
                        background: "#FFFFFF",
                        "& .MuiSelect-select": {
                          opacity: interval == null ? "0.5" : "1",
                        },
                      }}
                      onChange={handleChangeInterval}
                      value={interval}
                      renderValue={interval !== null ? undefined : () => "Select Interval"}
                    >
                      <MenuItem disabled={intervalDisabled["1m"]} value="1m">
                        Minutes
                      </MenuItem>
                      <MenuItem disabled={intervalDisabled["5m"]} value="5m">
                        Five Minutes
                      </MenuItem>
                      <MenuItem disabled={intervalDisabled["1h"]} value="1h">
                        Hour
                      </MenuItem>
                      <MenuItem disabled={intervalDisabled["1d"]} value="1d">
                        Day
                      </MenuItem>
                      <MenuItem disabled={intervalDisabled["7d"]} value="7d">
                        Week
                      </MenuItem>
                      <MenuItem disabled={intervalDisabled["30d"]} value="30d">
                        Month
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                {/* Date Range Picker */}
                <Box
                  sx={{
                    mr: 2,
                    mt: { xs: 3 },
                    width: { xs: "100%", sm: "21em" },
                  }}
                >
                  <DateRangeWithTime
                    setDateRangeChange={handleChangeDate}
                    dateRange={dateRange}
                    onlyAtFirstDetailLoading={onlyAtFirstDetailLoading}
                    onlyAtSecondDetailLoading={onlyAtSecondDetailLoading}
                    fromPage="detail"
                  />
                </Box>
                {/* Download Report Button */}
                <Box sx={{ mt: { xs: 3 }, width: { xs: "100%", sm: "auto" } }}>
                  <Button
                    variant="contained"
                    startIcon={<DownloadIcon />}
                    onClick={handleExport}
                    disabled={!substancedetails?.measures?.length}
                  >
                    Download Report
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
          }

          {/* Graph Section */}
          {thirdPartySummary ?
            (<Box sx={{ p: 3 }}>
              <Grid item container>
                <Card
                  sx={{
                    minWidth: "100%",
                    backgroundColor: summaryLoader && substanceChange ? "#f0f0f0" : "inherit",
                  }}
                >
                  <ReactApexChart
                    options={{
                      ...thirdPartygraphDataOptions.options,
                      chart: {
                        ...thirdPartygraphDataOptions.options.chart,
                        selection: {
                          enabled: false, // Disable selection
                        },
                      },
                      dataLabels: {
                        enabled: false, // Disable data labels
                      },
                    }}
                    series={[
                      {
                        name: "Metric Name", // or whatever the series represents
                        data: thirdPartygraphDataSeries, // your data array
                      },
                    ]}
                    type="bar"
                    height={350}
                  />


                </Card>
              </Grid>
            </Box>)
            : (
              <Box sx={{ position: "relative", mt: 2, px: 3 }}>                
                <Grid
                  container
                  spacing={2}
                  sx={{
                    pointerEvents: summaryLoader && substanceChange ? "none" : "auto",
                    opacity: summaryLoader && substanceChange ? 0.6 : 1,
                    filter: summaryLoader && substanceChange ? "blur(2px)" : "none",
                  }}
                >
                  <Grid item container>
                    <Card
                      sx={{
                        minWidth: "100%",
                        backgroundColor: summaryLoader && substanceChange ? "#f0f0f0" : "inherit",
                      }}
                    >
                      {graphDataSeries?.length > 0 ? (
                        <ReactApexChart
                          options={{
                            ...graphDataOptions.options,
                            tooltip: {
                              ...graphDataOptions.options?.tooltip,
                              y: {
                                ...graphDataOptions.options?.tooltip?.y,
                                formatter: (value: any) =>
                                  checkWithSubstanceOneDecimal.includes(substance?.substanceKey)
                                    ? value.toFixed(1) + getSubstanceUnit()
                                    : value + getSubstanceUnit(),
                              },
                            },
                          }}
                          series={[{ name: "", data: graphDataSeries }]}
                          type="bar"
                          height={350}
                        />
                      ) : !loading && !customLoader ? (
                        <Typography
                          sx={{
                            textAlign: "center",
                            m: 1,
                            fontSize: 14,
                          }}
                        >
                          Graph data is not available for characteristics{" "}
                          {substance?.substance?.toUpperCase()} for the selected date range.
                          <br />
                          Please change the date range or select another characteristics.
                        </Typography>
                      ) : (
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          {(loading || customLoader) && <DetailSkeleton filter={false} substance={false} graph={true} />}
                        </Box>
                      )}
                    </Card>
                  </Grid>
                </Grid>
                {(summaryLoader || isLoading) && substanceChange && (
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(255, 255, 255, 0.6)",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      zIndex: 10,
                    }}
                  >
                    <CircularProgress size={40} />
                  </Box>
                )}
              </Box>
            )}
        </>
      ) : (
        // Fallback message if maxWrostData is not available
        !customLoader &&
        !loading && (
          <Card sx={{ textAlign: "center", m: 10 }}>
            <Typography sx={{ fontSize: 14 }}>
              Sorry for the inconvenience,
              <br />
              it seems that the data for the characteristic, room, or device is currently unavailable.
            </Typography>
          </Card>
        )
      )}

      {/* Related Substances Section */}
      {(summaryLoader || relatedSubstancesLoader) ? (
        <DetailSkeleton filter={false} substance={true} graph={false} />
      ) : (
        <>
          {relatedSubstanceData?.length > 0 && (
            <Grid container mt={3}>
              <Typography sx={{ ml: 2, fontWeight: 600, textDecoration: "underline" }} variant="h6">
                Related Characteristics
              </Typography>
            </Grid>
          )}
          <Grid container mt={0}>
            {relatedSubstanceData?.length > 0 &&
              relatedSubstanceData.map((aggMeasItem: any, index: number) => (
                <Fragment key={index}>
                  {aggMeasItem?.substances?.length > 0 && (
                    <>
                      <Box
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          mb: 1,
                          ml: 2,
                        }}
                      >
                        <Grid container spacing={0} mt={1} ml={0}>
                          <Box className="alignItms">
                            <LabelIcons type={"R"} />
                            <Typography sx={{ fontWeight: 600 }} variant="subtitle1">
                              {aggMeasItem?.locationName}
                            </Typography>
                          </Box>
                        </Grid>
                      </Box>
                      {aggMeasItem?.substances
                        ?.sort((a: any, b: any) => b.index - a.index)
                        ?.map((item: any) => (
                          <CardComponent
                            key={item.substanceKey}
                            item={item}
                            variant={variant}
                            location={aggMeasItem?.location}
                            getSummaryData={HandleRealatedSub}
                            isRelatedData={aggMeasItem.roomData}
                          />
                        ))}
                    </>
                  )}
                </Fragment>
              ))}
          </Grid>
        </>
      )}
    </>
  );
}
